import React from "react";
import { Link } from 'react-router-dom'; // Import Link
import Icon from "../../../components/AppIcon";

const ProductTable = ({
  columns,
  data,
  loading,
  onSort,
  sortConfig
}) => {
  // Get sort direction icon
  const getSortDirectionIcon = (key) => {
    if (sortConfig.key !== key) return "ArrowUpDown";
    return sortConfig.direction === "asc" ? "ArrowUp" : "ArrowDown";
  };

  // Loading skeleton
  if (loading) {
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-border">
          <thead className="bg-surface">
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  className={`px-4 py-3 text-left text-sm font-medium text-text-secondary tracking-wider ${
                    column.width || ""
                  }`}
                >
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-border">
            {[...Array(5)].map((_, index) => (
              <tr key={index}>
                {columns.map((column) => (
                  <td key={`${index}-${column.key}`} className="px-4 py-3 whitespace-nowrap">
                    <div className="h-8 bg-surface animate-pulse rounded"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-border">
        <thead className="bg-surface">
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className={`px-4 py-3 text-left text-sm font-medium text-text-secondary tracking-wider ${
                  column.width || ""
                }`}
              >
                <div className="flex items-center">
                  <span>{column.header}</span>

                  {column.sortable && (
                    <button
                      className="ml-1 focus:outline-none"
                      onClick={() => onSort(column.key)}
                      aria-label={`Sort by ${column.header}`}
                    >
                      <Icon
                        name={getSortDirectionIcon(column.key)}
                        className="text-text-tertiary"
                        size={16}
                      />
                    </button>
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-border">
          {data.map((item) => (
            <tr key={item.id} className="hover:bg-surface transition-colors">
              {columns.map((column) => (
                <td
                  key={`${item.id}-${column.key}`}
                  className="px-4 py-3 whitespace-nowrap"
                >
                  {/* Check if the column is the product name column and render as a Link */}
                  {column.key === 'name' ? (
                    <Link
                      to={`/products/${item.id}`} // Use item.id for the product ID in the URL
                      className="text-secondary text-semibold hover:underline product-name-cell"
                    >
                      {item[column.key]}
                    </Link>
                  ) : column.render ? (
                    column.render(item)
                  ) : (
                    item[column.key]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;